import COS from 'helper/cos/cos-js-sdk-v5';
import eventProxy from 'tools/eventProxy';
import storage, { StoreKey } from 'tools/storage';
import { queryStringParse } from 'tools/utils';
import dao from 'helper/dao';
import { generatePolicy, getPolicySign } from 'helper/cos/policySign';

const cos = new COS();

// cos.on('before-send', opt => {
//   // const { headers } = opt;
//   // 给cosbrowser分享网页版带上通道头部
//   headers['x-cos-channel-id'] = 'cosbrowser_web';
// });

const credentials = {
  // policy 签名所需信息
  policyInfo: {
    Bucket: '',
    Prefix: '',
    action: [],
    files: [],
    SecretId: '',
    keytime: '',
    signKey: '',
  },

  // 临时密钥信息
  TmpSecretId: '',
  TmpSecretKey: '',
  XCosSecurityToken: '',

  // 外链有效时长
  ExpiredTime: '',
};

/**
 * @description 获取有效的 policy 签名中间产物
 * @return {*}
 */
async function getValidSignKey() {
  const { policyInfo } = credentials;
  const [, end] = policyInfo.keytime.split(';');
  const now = Math.round(Date.now() / 1000);

  const id = storage.get(StoreKey.ID);
  const { id: currShareId } = queryStringParse(window.location.search.substr(1));
  if (currShareId !== id) {
    // 检测到当前分享外链 id 与缓存里不一致则刷新页面
    window.location.reload();
  }
  // keytime 为空，第一次发请求 || keytime 再过五分钟就失效
  if (!policyInfo.keytime || now > +end + 5 * 60) {
    const extract = storage.get(StoreKey.EXTRACT);
    const { keytime: nextKeytime, signKey: nextSignKey } = await dao.getSignKey({ id, extract });
    Object.assign(credentials.policyInfo, {
      keytime: nextKeytime,
      signKey: nextSignKey,
    });
  }

  return { keytime: policyInfo.keytime, signKey: policyInfo.signKey };
}

export function setCredentials(info) {
  credentials.ExpiredTime = info.expire;
  // 临时密钥信息
  credentials.TmpSecretId = info.sid;
  credentials.TmpSecretKey = info.skey;
  credentials.XCosSecurityToken = info.token;
  // policy 签名信息
  credentials.policyInfo = {
    SecretId: info.secretId || '',
    Bucket: info.Bucket,
    Prefix: info.Prefix,
    action: info.action,
    files: info.files,
    signKey: '',
    keytime: '',
  };

  // 若分享外链信息里有 secretId 字段，则说明可以使用 policy 签名
  if (info.secretId) {
    cos.options.getAuthorization = (options, callback) => {
      getValidSignKey().then(({ keytime, signKey }) => {
        const { policyInfo } = credentials;
        const policy = generatePolicy({
          ...policyInfo,
          keytime,
        });
        const auth = getPolicySign({
          SecretId: policyInfo.SecretId,
          keytime,
          signKey,
          policy,
          method: options.Method,
          ...options,
        });
        callback(auth);
      });
    };
  } else {
    // 分享外链里只有临时密钥信息，直接设置给 SDK
    cos.options.SecretId = credentials.TmpSecretId;
    cos.options.SecretKey = credentials.TmpSecretKey;
    cos.options.XCosSecurityToken = credentials.XCosSecurityToken;
  }
}

const defaultGetAuthFn = cos.getAuth;
cos.getAuth = params => new Promise((resolve, reject) => {
  if (credentials.SecretId) {
    // 使用 policy 签名方式
    cos.options.getAuthorization(params, resolve);
    return;
  }
  try {
    const auth = defaultGetAuthFn.call(cos, params);
    resolve(auth);
  } catch (error) {
    reject(error);
  }
});

// TODO: 本地开发时可能会跨域，getBucket 接口要给存储桶设置跨域 origin
// cos.getBucket = async function getBucket(params) {
//   params.MaxKeys = params.MaxKeys || 200;
//   params.Marker = params.Marker || '';

//   const authParams = {
//     ...(credentials.SecretId
//       ? { SecretId: credentials.SecretId }
//       : { SecretId: credentials.TmpSecretId, SecretKey: credentials.TmpSecretKey }),
//     Method: 'GET',
//     Query: {
//       prefix: params.Prefix,
//       marker: params.Marker,
//       ...(params.Delimiter && { delimiter: params.Delimiter }),
//       'max-keys': params.MaxKeys,
//     },
//   };

//   const Authorization = await cos.getAuth(authParams);
//   const _params = {
//     ...params,
//     Authorization,
//     ...(!credentials.SecretId && { XCosSecurityToken: credentials.XCosSecurityToken }),
//   };

//   return request.get('/cos/object/list', { params: _params }).then(res => {
//     const { ListBucketResult } = res;

//     let Contents = ListBucketResult.Contents || [];
//     let CommonPrefixes = ListBucketResult.CommonPrefixes || [];

//     Contents = _.isArray(Contents) ? Contents : [Contents];
//     CommonPrefixes = _.isArray(CommonPrefixes) ? CommonPrefixes : [CommonPrefixes];
//     return Promise.resolve({ ...ListBucketResult, Contents, CommonPrefixes });
//   });
// };

cos.on('list-update', data => {
  eventProxy.emit('upload-list-update', data);
});

export { cos };
